import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';

import { send_to_server } from '@/services/socketio_client_react/send_to_server';

import { DTO__file_data } from '@shared/dto/+image/image_asset_base/DTO__file_data';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { StateUser } from '../state_user';

export const remote_user_settings_update_avatar = createAsyncThunkSafe<string, DTO__file_data>(
  ENUM__network_event_client_to_server.USER_SETTINGS_UPDATE_USER_AVATAR,
  async (file_data): Promise<string> => {
    return await send_to_server<string>(ENUM__network_event_client_to_server.USER_SETTINGS_UPDATE_USER_AVATAR, file_data);
  },
);

export function init_remote_user_settings_update_avatar(builder: ActionReducerMapBuilder<StateUser>) {
  builder
    .addCase(remote_user_settings_update_avatar.pending, state => {})
    .addCase(remote_user_settings_update_avatar.rejected, (state, action) => {})
    .addCase(remote_user_settings_update_avatar.fulfilled, (state, action: PayloadAction<string>) => {
      state.user_url_relative_avatar = action.payload;
    });
}
